import ActionCondition, { any, SpecificLinkOption } from 'cio/app-models/conditions/action';
import { anyEmail } from 'cio/app-models/conditions/email';
import refinement from './refinement';

const LINK_EVENT_TYPES = ['clicked_action', 'clicked_email'];

export default function (obj: ActionCondition, translateToEmailType = false) {
  let { action, eventType, isForeignEvent, inverse, isVariation, specificLink, linkHref } = obj;
  let { times, within } = refinement(obj);
  let requiresLinkFilter = LINK_EVENT_TYPES.includes(eventType) && specificLink !== SpecificLinkOption.None;
  let name = action as string;
  let filters = {};

  if (name?.includes('any_') && name !== any(obj.type)) {
    name = name.replace('any_', '');
  }

  if (translateToEmailType) {
    eventType = eventType.replace('action', 'email');

    if (action?.includes('email_*')) {
      action = anyEmail;
    }
  }

  if (isVariation) {
    // name comes in as ":channel_newsletter_:newsletterId_variation_:templateId" for variations
    let [channel, parentType, newsletterId, templateId] = name.split('_').filter((seg) => seg !== 'variation');
    let variationFilter = serializeVariation(templateId);

    // eg "push_newsletter_10"
    name = `${channel}_${parentType}_${newsletterId}`;

    if (requiresLinkFilter) {
      filters = {
        and: [variationFilter, serializeSpecificLink(linkHref as string, specificLink)],
      };
    } else {
      filters = variationFilter;
    }
  } else if (requiresLinkFilter) {
    let filter = {
      ...serializeSpecificLink(linkHref as string, specificLink),
    };
    if (action?.includes('in_app')) {
      // we name it differently for in-app. The inverse mapping happens on deserialization
      filter.field = 'action_name';
    }
    filters = filter;
  }

  return {
    event: {
      name,
      filters,
      type: eventType,
    },
    times,
    within,
    inverse,
    isForeignEvent,
  };
}

function serializeVariation(templateId: string) {
  return {
    field: 'template_id',
    operator: 'eq',
    value: templateId,
    inverse: false,
  };
}

function serializeSpecificLink(linkHref: string, specificLink: SpecificLinkOption) {
  return {
    field: 'href',
    operator: specificLinkOperatorToOption(specificLink),
    value: linkHref,
    inverse: false,
  };
}

function specificLinkOperatorToOption(option?: SpecificLinkOption) {
  switch (option) {
    case SpecificLinkOption.Contains:
      return 'contains';
    case SpecificLinkOption.Exact:
      return 'eq';
    case SpecificLinkOption.None:
      return 'none';
    default:
      throw new Error(`Unknown specific link option: ${option}`);
  }
}
